import React, { lazy, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { ADMIN_API, USER_API } from "./common/common";
import { getDomain, Logout } from "./common/Funcation";
import {
  normalizeMobileHeaderId,
  writeHeaderCache,
} from "./common/mobileHeader";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import {
  getApi,
  postApi,
  postApiAdmin,
  sendEvent,
  socketConnect,
} from "./service";
import PageNotFound from "./pages/PageNotFound";
import Home from "./pages/Home";
import Maintenance from "./pages/Maintenance";
import Inplay from "./pages/Inplay/Inplay";
import MultiMarket from "./pages/MultiMarket/MultiMarket";
import Cricket from "./pages/Sport/Cricket";
import Soccer from "./pages/Sport/Soccer";
import Tennis from "./pages/Sport/Tennis";
import BasketBall from "./pages/Sport/BasketBall";
import Esoccer from "./pages/Sport/Esoccer";

const Login = lazy(() => import("./pages/Login"));
const ChangePassword = lazy(() => import("./pages/ChangePassword"));
const DepositWithdraw = lazy(() => import("./pages/DepositWithdraw"));
const MyAccount = lazy(() => import("./pages/MyAccount"));
const MyAccountMobile = lazy(() => import("./pages/MyAccountMobile "));

const cookies = new Cookies();
const Router = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
  const HeaderData = useSelector((e: any) => e.Header);
  const isMaintenance = useSelector(
    (e: any) => e.domainDetails?.isMaintenance === true,
  );
  const [siteChecked, setSiteChecked] = useState(false);

  useEffect(() => {
    socketConnect(dispatch, (flag: any) => {
      if (flag) {
        setTimeout(() => {
          sendEvent("GET_LIVE_MATCH_COUNT", {});
        }, 500);
      }
    });
    getDomainDetails();
    return () => {};
  }, []);

  useEffect(() => {
    const authToken = cookies.get("skyTokenFront");
    if (!authToken) return;
    // Login already stored the profile. Fetch it only when this session does not have it yet.
    if (!HeaderData?._id) {
      getHeaderDetails();
    }
    getMarketListDetails();
  }, [isAuthenticated]);

  useEffect(() => {
    const authToken = cookies.get("skyTokenFront");
    if (!authToken || !HeaderData?._id) return undefined;
    const signUpTimer = setTimeout(() => {
      sendEvent("SIGN_UP", { userId: HeaderData._id });
    }, 500);
    const verifyTimer = setTimeout(() => {
      sendEvent("VERIFY_TOKEN", {
        userId: HeaderData._id,
        token: authToken,
      });
      sendEvent("UPDATE_USER_BALANCE", { userId: HeaderData._id });
    }, 700);
    return () => {
      clearTimeout(signUpTimer);
      clearTimeout(verifyTimer);
    };
  }, [HeaderData?._id, isAuthenticated]);

  const getHeaderDetails = async () => {
    let data = {
      api: USER_API.GET_PROFILE,
      value: {},
    };
    await getApi(data)
      .then(function (response) {
        dispatch({ type: "HEADER_DETAILS", payload: response.data.data });
        if (
          response.data.data.newPassword &&
          window.location.pathname !== "/change/password"
        ) {
          window.location.href = "/change/password";
        }
      })
      .catch((err) => {
        if (err.response?.data?.statusCode === 401) {
          Logout();
        }
      });
  };
  const getDomainDetails = async () => {
    let data = {
      api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
      value: {
        domain: getDomain(),
      },
    };
    await postApiAdmin(data)
      .then(function (response) {
        if (response.data.data) {
          dispatch({ type: "DOMAIN_DETAILS", payload: response.data.data });
          writeHeaderCache(
            normalizeMobileHeaderId(response.data.data.mobileHeader),
          );
          if (response?.data?.data?.isMaintenance === true) {
            if (window.location.pathname.toLowerCase() !== "/maintenance") {
              navigate("/maintenance", { replace: true });
            }
          }
        } else {
          navigate("/404");
        }
      })
      .catch((err) => {
        if (err.response?.data?.statusCode === 401) {
          Logout();
        } else {
          navigate("/404");
        }
      })
      .finally(() => {
        setSiteChecked(true);
      });
  };
  const getMarketListDetails = async () => {
    let data = {
      api: USER_API.MARKET_LIST,
      value: {},
    };
    await getApi(data)
      .then(function (response) {
        dispatch({ type: "MARKET_LIST_DETAILS", payload: response.data.data });
      })
      .catch((err) => {
        if (err.response?.data?.statusCode === 401) {
          Logout();
        }
      });
  };
  useEffect(() => {
    if (!siteChecked || !isMaintenance) return;
    if (window.location.pathname.toLowerCase() === "/maintenance") return;
    navigate("/maintenance", { replace: true });
  }, [siteChecked, isMaintenance, navigate]);

  if (!siteChecked) return null;
  if (isMaintenance) return <Maintenance />;

  return (
    <>
      <Routes>
        <Route path={`/404`} element={<PageNotFound />} />
        <Route path={`/`} element={<Home />} />
        <Route
          path={`/login`}
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path={`/profile`}
          element={
            <PrivateRoute>
              <MyAccount />
            </PrivateRoute>
          }
        >
          <Route
            path={`:tab/`}
            element={
              <PrivateRoute>
                <MyAccount />
              </PrivateRoute>
            }
          />
          <Route
            path={`/profile`}
            element={
              <PrivateRoute>
                <MyAccount />
              </PrivateRoute>
            }
          />
        </Route>
        <Route
          path={`/user/:tab/`}
          element={
            <PrivateRoute>
              <MyAccount />
            </PrivateRoute>
          }
        />
        <Route
          path={`/user/:tab`}
          element={
            <PrivateRoute>
              <MyAccount />
            </PrivateRoute>
          }
        />
        <Route
          path={`/myAccount`}
          element={
            <PrivateRoute>
              <MyAccountMobile />
            </PrivateRoute>
          }
        />
        <Route
          path={`/d-w`}
          element={
            <PrivateRoute>
              <DepositWithdraw />
            </PrivateRoute>
          }
        />

        <Route
          path={`/change/password`}
          element={
            <>
              <ChangePassword />
            </>
          }
        />
        <Route path={`/maintenance`} element={<Maintenance />} />
        <Route path={`/in-play`} element={<Inplay />} />
        <Route path={`/cricket`} element={<Cricket />} />
        <Route path={`/soccer`} element={<Soccer />} />
        <Route path={`/tennis`} element={<Tennis />} />
        <Route path={`/Esoccer`} element={<Esoccer />} />
        <Route path={`/basketBall`} element={<BasketBall />} />
        <Route path={`/multimarket`} element={<MultiMarket />}>
          <Route path={`:eventId/:marketId`} element={<MultiMarket />} />
        </Route>
      </Routes>
    </>
  );
};

export default Router;
